import { useGdsServicesCalculatedCountInfo } from './useGdsServicesCalculatedCountInfo';
import { getGdsServiceCalculatedCountInfo } from './getGdsServiceCalculatedCountInfo';
export function useGetGdsServicesCalculatedCountInfo() {
    const gdsServicesCalculatedLimitInfo = useGdsServicesCalculatedCountInfo();
    return (passengerId, segmentId, params) => getGdsServiceCalculatedCountInfo(passengerId, segmentId, gdsServicesCalculatedLimitInfo, params);
}
